module.exports = __webpack_public_path__ + "static/support_step_01@2x-2d2f20e024a2e94958a1cf75620e87f1.png";